import Avatar from "../../common/Avatar";
import SearchBar from "./SearchBar";
import { useDispatch } from "react-redux";
import { openModal } from "../../../features/globalModalSlice";
import { users } from "../../../fake-db/users";

const LeftSidebarHeader = () => {
  const dispatch = useDispatch();

  return (
    <div className="grid grid-cols-5 border-b sm:h-[50px] md:h-[65px] sm:px-2 md:px-5">
      <div className="col-span-1 flex items-center">
        <button onClick={() => dispatch(openModal("left"))}>
          <Avatar isSmall={false} data={users[0]} activeStatus />
        </button>
      </div>
      <div className="col-span-4 flex items-center">
        <SearchBar />
      </div>
    </div>
  );
};

export default LeftSidebarHeader;
